/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErroreClientProblemaListFilter } from './errore-client-problema-list-filter';
import { Problema } from './problema';


export interface ErroreClientExportDTO { 
    generato_il?: string;
    filtri?: ErroreClientProblemaListFilter;
    totale_problemi?: number;
    troncato?: boolean;
    occorrenze_per_problema?: number;
    problemi?: Array<Problema>;
}

